<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list" v-if="!loading && gep">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div>
              <div class="d-flex justify-space-between px-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      @click="$router.go(-1)"
                      icon
                      ><v-icon>mdi-reply</v-icon></v-btn
                    >
                  </template>
                  <span>Back</span>
                </v-tooltip>
              </div>
              <h3 style="text-align: center" class="mb-2">
                Managing Proposal GEP
              </h3>
            </div>
            <v-tabs centered color="green" slider-size="4" v-model="tab">
              <v-tab class="text-capitalize"> <b>Response</b> </v-tab>
              <v-tab class="text-capitalize"> <b>Guideline</b> </v-tab>
            </v-tabs>
          </v-card>
        </div>
        <v-tabs-items v-model="tab" style="background: none">
          <v-tab-item class="pa-1">
            <div>
              <list-response-gep />
            </div>
          </v-tab-item>
          <v-tab-item class="pa-1">
            <div>
              <v-card flat class="rounded_max pa-4" style="overflow: hidden">
                <h4>Link for Guideline</h4>
                <h5 class="my-3" style="font-weight: normal">Link Guideline</h5>
                <v-textarea
                  v-if="!gep.guideline || editLinkForm"
                  class="my-2 rounded-lg"
                  auto-grow
                  outlined
                  rows="4"
                  hide-details
                  dense
                  placeholder="Put the link here"
                  @blur="updateLink('form')"
                  v-model="linkForm"
                ></v-textarea>
                <v-card
                  v-if="gep.guideline && !editLinkForm"
                  flat
                  outlined
                  class="pa-2 rounded-lg"
                >
                  <div class="pa-1 d-flex align-center justify-start">
                    <v-card
                      class="pa-3 rounded-lg d-flex justify-center align-center"
                      color="#757575"
                      flat
                      dark
                    >
                      <v-icon>mdi-link-variant</v-icon>
                    </v-card>
                    <div class="ml-2" style="width: 85%">
                      <a :href="gep.guideline" target="_blank">
                        <h5 style="width: 100%">
                          {{ gep.guideline }}
                        </h5>
                      </a>
                    </div>
                  </div>
                </v-card>
                <p class="small_txt">
                  Date modified
                  {{ $date(gep.updated_at).format("DD MMMM YYYY") }}
                </p>
                <div
                  class="mt-2 d-flex justify-end"
                  v-if="
                    gep.guideline &&
                    !editLinkForm &&
                    (permissions.includes('UPCM') || role == 'SUPERADMIN')
                  "
                >
                  <v-btn
                    small
                    color="red"
                    dark
                    depressed
                    @click="linkEdited(false, 'form')"
                    >Delete</v-btn
                  >
                  <v-btn
                    small
                    class="ml-2"
                    color="#016443"
                    dark
                    depressed
                    @click="linkEdited(true, 'form')"
                    >Edit</v-btn
                  >
                </div>
              </v-card>
            </div>
            <!-- <v-card flat class="rounded_max pa-4 mt-4" style="overflow: hidden"
              ><h4>Link for Proposal</h4>
              <h5 class="my-3" style="font-weight: normal">Link JOTFORM</h5>
              <v-textarea
                v-if="!gep.guideline || editLinkJot"
                class="my-2 rounded-lg"
                auto-grow
                outlined
                rows="4"
                hide-details
                dense
                placeholder="Put the link here"
                @blur="updateLink('jot')"
                v-model="linkJot"
              ></v-textarea>
              <v-card
                flat
                outlined
                class="pa-2 rounded-lg"
                v-if="gep.guideline && !editLinkJot"
              >
                <div class="pa-1 d-flex align-center justify-start">
                  <v-card
                    class="pa-3 rounded-lg d-flex justify-center align-center"
                    color="#757575"
                    flat
                    dark
                  >
                    <v-icon>mdi-link-variant</v-icon>
                  </v-card>
                  <div class="ml-2" style="width: 85%">
                    <a :href="gep.guideline" target="_blank">
                      <h5 style="width: 100%">{{ gep.guideline }}</h5>
                    </a>
                  </div>
                </div>
              </v-card>

              <div
                class="mt-2 d-flex justify-end"
                v-if="
                  gep.guideline &&
                  !editLinkJot &&
                  (permissions.includes('UPCM') || role == 'SUPERADMIN')
                "
              >
                <v-btn
                  small
                  color="red"
                  dark
                  depressed
                  @click="linkEdited(false, 'jot')"
                  >Delete</v-btn
                >
                <v-btn
                  small
                  class="ml-2"
                  color="#016443"
                  dark
                  depressed
                  @click="linkEdited(true, 'jot')"
                  >Edit</v-btn
                >
              </div>
            </v-card> -->
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div v-if="loading" class="_temp_list">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pb-3">
              <v-skeleton-loader
                type="article"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-avatar-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import vue2Dropzone from "vue2-dropzone";
import ListResponseGep from "./responseGep/listResponseGep.vue";
export default {
  name: "proposalGep",
  components: {
    vueDropzone: vue2Dropzone,
    ListResponseGep,
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      loadingUplaod: false,
      loadingText: false,
      tab: null,
      err: "",
      updating: false,
      isUpdate: false,
      dataSet: null,
      msg: "",
      file: null,
      overlay: false,
      linkJot: "",
      linkForm: "",
      editLinkForm: false,
      editLinkJot: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        acceptedFiles: ".jpeg, .pdf, .png, .jpg, .docx",
        uploadMultiple: false,
        previewTemplate: this.template(),
        maxFilesize: 5,
      },
      gep: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    linkEdited(isEditLink, type) {
      if (isEditLink) {
        if (type == "jot") {
          this.linkJot = this.gep.guideline;
          this.editLinkJot = true;
        } else {
          this.linkForm = this.gep.guideline;
          this.editLinkForm = true;
        }
      } else {
        if (type == "jot") {
          this.linkJot = "";
          this.gep.guideline = null;
          this.editLinkJot = false;
        } else {
          this.linkForm = "";
          this.gep.guideline = null;
          this.editLinkForm = false;
        }
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `proposal`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          data.data.forEach((proposal) => {
            if (proposal.type == "gep") {
              this.gep = proposal;
            }
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
        });
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-details" style="display:none;">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress" style="display:none;"><span class="dz-upload" data-dz-uploadprogress></span></div>
            </div>
        `;
    },
    updateLink(type) {
      this.loadingText = true;
      let file = new FormData();
      file.append("id", this.gep.id);
      if (type == "jot") {
        file.append("guideline", this.linkJot);
      } else {
        file.append("guideline", this.linkForm);
      }

      let data = {
        path: `proposal/update`,
        body: file,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.editLinkForm = false;
          this.editLinkJot = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.fetchData();
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.errMsg = err;
        });
      this.loadingText = false;
    },
  },
};
</script>

<style scoped>
#dropzone {
  display: flex;
  justify-content: center;
  border-radius: 10px;
  color: #777;
  border: 1px dashed;
  transition: background-color 0.2s linear;
  min-height: 60px;
  width: 100%;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #59919e;
}
.primary-color {
  color: #59919e;
}
.subtitle {
  color: #314b5f;
}
#dropzone .dz-preview {
  display: none;
  overflow: hidden;
}

.temp_dz {
  background: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
  -webkit-box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
  -moz-box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
  box-shadow: 0px 10px 21px 11px rgba(3, 169, 244, 0.07) !important;
}
</style>
